import { useAuth } from "@/_core/hooks/useAuth";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { trpc } from "@/lib/trpc";
import { ArrowLeft } from "lucide-react";
import { useState } from "react";
import { useLocation } from "wouter";
import { toast } from "sonner";

export default function Profile() {
  const { user } = useAuth();
  const [, navigate] = useLocation();

  const [operatorInitial, setOperatorInitial] = useState(user?.operatorInitial || "");

  const { logout } = useAuth();
  const updateInitialMutation = trpc.auth.updateOperatorInitial.useMutation();

  const handleSaveInitial = async () => {
    try {
      await updateInitialMutation.mutateAsync({ operatorInitial });
      toast.success("Operator initial updated");
    } catch (error) {
      toast.error("Failed to update initial");
    }
  };

  const handleLogout = logout;

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b bg-card sticky top-0 z-10">
        <div className="container py-4">
          <div className="flex items-center gap-4">
            <Button variant="ghost" size="sm" onClick={() => navigate("/")}>
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back
            </Button>
            <h1 className="text-xl font-bold">Profile</h1>
          </div>
        </div>
      </header>

      <main className="container py-6 max-w-2xl">
        <div className="space-y-6">
          {/* User Info */}
          <Card>
            <CardHeader>
              <CardTitle>User Information</CardTitle>
              <CardDescription>Your account details</CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <div>
                <Label>Name</Label>
                <p className="text-sm mt-1">{user?.name || "Not set"}</p>
              </div>
              <div>
                <Label>Email</Label>
                <p className="text-sm mt-1">{user?.email || "Not set"}</p>
              </div>
              <div>
                <Label>Role</Label>
                <p className="text-sm mt-1 capitalize">{user?.role}</p>
              </div>
            </CardContent>
          </Card>

          {/* Operator Settings */}
          <Card>
            <CardHeader>
              <CardTitle>Operator Settings</CardTitle>
              <CardDescription>Configure your operator preferences</CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <div>
                <Label htmlFor="initial">Operator Initial</Label>
                <Input
                  id="initial"
                  maxLength={10}
                  value={operatorInitial}
                  onChange={(e) => setOperatorInitial(e.target.value)}
                  placeholder="e.g., JD"
                />
                <p className="text-xs text-muted-foreground mt-1">
                  This will be used as the default initial in daily logs
                </p>
              </div>
              <Button onClick={handleSaveInitial}>Save Initial</Button>
            </CardContent>
          </Card>

          {/* Account Actions */}
          <Card>
            <CardHeader>
              <CardTitle>Account Actions</CardTitle>
            </CardHeader>
            <CardContent>
              <Button variant="destructive" onClick={handleLogout}>
                Sign Out
              </Button>
            </CardContent>
          </Card>
        </div>
      </main>
    </div>
  );
}
